// Section Registry - Maps section slugs from page JSON to pre-defined React components
// These components receive pre-fetched data from the server side

import { ComponentType } from 'react';
import ImageVideo from '@/components/PageComponents/ImageVideo';
import TrendingTab from '@/components/PageComponents/TrendingTab';
import Astrologycollection from '@/components/component_astro_crick/Astrologycollection';
import AstroNumbersGrid from '@/components/component_astro_crick/AstroNumbersGrid';
import AtrologyNewsImageAdd from '@/components/component_astro_crick/AtrologyNewsImageAdd';
import HorizontalSmallImageCategoryNews from '@/components/component_horizontal/HorizontalSmallImageCategoryNews';
import astroweeklymonthly from '@/components/component_astro_crick/astroweeklymonthly';
import IconWithtext from '@/components/component_astro_crick/IconWithtext';
import ChipsFormIconBuilder from '@/components/component_form/ChipsFormIconbuilder';

// Registry mapping section slugs to components
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sectionRegistry: Record<string, any> = {
  // Page section components - receive pre-fetched data as props
  'image-video': ImageVideo,
  'trending-tab': TrendingTab,
  'recent-news': TrendingTab,
  'page-foot-section': ImageVideo,
  astroweeklymonthly: astroweeklymonthly,
  astrologycollection: Astrologycollection,
  AstroNumbersGrid: AstroNumbersGrid,
  AtrologyNewsImageAdd: AtrologyNewsImageAdd,
  HorizontalSmallImageCategoryNews: HorizontalSmallImageCategoryNews,
  IconWithText: IconWithtext,
  // 'breakingnews':BreakingNews
  trendingtags: ChipsFormIconBuilder,

  // Add more section mappings as needed
};

// Get a section component by slug
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getSectionComponent(slug: string): ComponentType<any> | null {
  return sectionRegistry[slug] || null;
}

// Check if a slug has a registered component
export function hasSectionComponent(slug: string): boolean {
  return slug in sectionRegistry;
}
